"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _content = _interopRequireDefault(require("./content.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Content = function Content(_ref) {
  var children = _ref.children;
  return _react["default"].createElement("div", {
    className: _content["default"]['content']
  }, _react["default"].createElement("div", null, children));
};

Content.propTypes = {};
Content.defaultProps = {};
var _default = Content;
exports["default"] = _default;